import { getEvents, getPhaseStatus, trimAction } from "./debriefingUtils";
// import { requiredPhaseNames } from "./analyzeEvents";
import {
  leafStatusList,
} from "@meddbriefer/feedback-data";

// constants
const summaryFields = [
  "label",
  "status",
  "phaseOrderStatus",
  "lateRelativeTo",
  "phase",
  "subPhase",
  "labelID",
  "phaseID",
  "probLabel",
  "answerCorrect",
  "answerDetails",
  "timestamp",
  "type",
];

// globals
let analysis;

// helper functions

//regularize status values, by examining status values grouped into categories
//of good, error, etc in leafStatusList
function regularizeStatus(event) {
  for (const [key, statuses] of Object.entries(leafStatusList)){
    if (statuses.includes(event.status)) {
      event.status = key
      break
    }
  }
  return event;
}

function determineStatusOfNotFound(id, promptIDarray) {
  if (!!itemsByID && !itemsByID[id]){
    idsNotFound.push(id)
  }
  if ((typeof id === 'string' && id.startsWith("request-")) || promptIDarray[id]){
    idsNotFound.pop()
    return "absent"
  }
  else {return "notFound"}  //notFound is an unidentified id (could be a typo in some
  //of the hand coded data or forgot an id in not indicated for the scenario
  //since now all interventions are categorized in the problem definition for a scenario)

}

function examineDups(events) {
  let newEvent
  let misordered = false
  let noError = false
  let interimEvent

  // will eventually need to separate any with variants from under the same eventID as not being
  //duplicatea.  But for now we have no feedback for variants so can ignore variants for now.

  //regularize status of each instance of event 
  //if any of the dups of event is without an error then can say there
  //are no errors.
  //However, if any of the dups are misordered then can report it as
  //misOrdered in the summary
  let lastEvent = events[events.length-1]
  newEvent = trimAction(lastEvent, summaryFields);
  
  if (events.length > 1) {
    for (const event of events) {
      interimEvent = regularizeStatus(event)
      if (!["error", "misorderedError"].includes(interimEvent.status)) {  //absent can't happen because if dups then wouldn't insert it was absent
        noError = true
      }
      if (["misordered", "misorderedError"].includes(interimEvent.status)) {
        misordered = true
      }
      if (misordered && noError) {
        break
      }
    }
    newEvent = regularizeStatus(newEvent)
    if (!misordered){
      if (!noError){
        newEvent.status = "error"}
      else {newEvent.status = "good"}
    }
    
    else {
      if (noError){
        newEvent.status = "misordered"}
      else {newEvent.status = "misorderedError"}
    } 
  }
  else {newEvent = regularizeStatus(newEvent)}
  
  return newEvent
}


// this is a recursive function
function processNextLevel(summary, top, decisionPromptIDs) {
  let results;
  let children = [];
  let childIDs = [];
  let statuses = [];
  let events;
  let newEvent;
  let dummyEvent = {
    id: top.id,
    status: "",
  };

  if (top.subActions.length === 0) {   //at a leaf node
    events = getEvents(analysis, "id", top.id);
    if (events.length !== 0) {   
      //examine potential duplicates to determine overall status for newEvent
      //need to do more than ... to get a deep copy of an array of objects
      const copyEvents = events.map(a => ({...a}));
      newEvent = examineDups(copyEvents)  
      statuses = [newEvent.status];
      childIDs.push(newEvent.id);
      children.push(newEvent);
    } else {  //didn't find the event; that means it isn't a recognized event or is specified as not indicated but is not present
      //all not indicated are specified in problem solutions now.  So their
      //presence will be marked as not indicated then as an error in the summary
      let status = determineStatusOfNotFound(top.id, decisionPromptIDs)  
      statuses = [status];
      dummyEvent.status = status;
      childIDs.push(top.id);
      children.push(dummyEvent);
      //alternative to above 2 lines to
      //remove notFound because confuses cond 2 algorithm.
      //However it wasn't requested that I remove these and
      //it made no difference in how the cond 2 algorithm
      //behaved, so I'll leave it out and discuss with Scott
      /* if (status !== "notFound"){
        childIDs.push(top.id);
        children.push(dummyEvent);} */
    }
    return [children, childIDs, statuses];
  } else {
    let header = {
      id: top.id,
      childIDs: [],
      children: [],
      status: "",
      phaseOrderStatus: "good",
      type: "header",
    };
    let event = getEvents(analysis, "labelID", top.id)[0];
    let headerStatus = ""
    if (!!event && !!event.phaseOrderStatus){
      headerStatus = event.phaseOrderStatus
      header.phaseOrderStatus = headerStatus
      if (!!event.lateRelativeTo && event.lateRelativeTo.length >= 1){
        header.lateRelativeTo = event.lateRelativeTo}
    }
    top.subActions.forEach((action) => {
      results = processNextLevel(summary, action, decisionPromptIDs);
      header.children = header.children.concat(results[0]);
      header.childIDs = header.childIDs.concat(results[1]);
      statuses = statuses.concat(results[2]);
    });
    
    
    if (headerStatus !== "" && headerStatus !== "good"){
      statuses = statuses.concat(headerStatus)}
    header.status = getPhaseStatus(statuses);
    summary[top.id] = [header].concat(header.children);
    delete header.children;
    return [[header], [header.id], [header.status]];
  }
}

let idsNotFound
let itemsByID = undefined

// main entry point (should be the only thing which needs to be exported)
export function summarizeAnalysis(analysisData, scenIEFeedback, itemByIDArray = undefined) {
  //if optional arg itemByIDArray is passed then will report leaf ids that were not found that are
  //used in the condition 2 data structure
  idsNotFound = []
  if (!!itemByIDArray) {
    itemsByID = itemByIDArray
  }
  const { events: finalActions, decisionPromptIDs } = analysisData
  let summary = {}; //holds results for condition 2
  analysis = finalActions;
  //work through the condition 2 DS and create entries for it and summarize status of children for the current level
  // if (scenarios[scen.name]) {
  let ds = scenIEFeedback.Action
  //scenarios[scen.name].Action;
  processNextLevel(summary, ds, decisionPromptIDs);

  
  if (idsNotFound.length !== 0) {
    console.log("idsNotFound: ", idsNotFound)
  }
  return summary;
}
